var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mx-auto my-4",attrs:{"max-width":"500"}},[_c('v-card-title',[_vm._v(" You are now logged in! ")]),_c('v-card-subtitle',[_vm._v(" Account features coming soon... ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }